module.exports = __webpack_public_path__ + "assets/img/5.png?79fa722b9c6d80893c033cd0a7d3cca5";